import styled from 'styled-components';
import {bgBody, gray200, gray500, gray600} from '../../shared/themes/color';

export const WorkContainer = styled.div`
  display: grid;
  grid-template: auto / 8fr 4fr;
  gap: 1.25rem;
  margin: 3rem 0;
  padding: 0 0 3rem 0;
  align-items: center;
  border-bottom: 1px solid ${gray200};

  :last-of-type {
    border: none;
  }

  @media (max-width: 1024px) {
    display: block;
  }
`;

export const DataContainer = styled.div`
  padding-left: 2.5rem;

  @media (max-width: 1024px) {
    margin: 2rem 0 0 0;
    padding-left: 0;
  }

  @media (max-width: 600px) {
    margin: 2.5rem 3.5rem 0 3.5rem;
  }
  
  h3 {
    margin-right: .25rem;
  }
`;

export const ActivityContainer = styled.div`
  margin-top: .5rem;

  ul {
    margin: 0;
    padding: 0;
    color: ${gray600};
    font-size: .87rem;

    li {
      position: relative;
      margin: 0 0 .25rem 0;
      list-style: none;
      line-height: 1.25rem;
      padding-left: 1.5rem;

      :before {
        content: '•';
        position: absolute;
        left: .25rem;
      }
    }
`;

export const Label = styled.span`
  display: block;
  margin: 0 0 .25rem 0;
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  line-height: .75rem;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${gray500};
`;

export const LabelType = styled.span`
  display: inline-block;
  margin-left: 0;
  margin-bottom: .2rem;
  padding: .25rem .35rem;
  vertical-align: middle;
  font-size: .62rem;
  font-weight: 600;
  letter-spacing: .5px;
  text-transform: uppercase;
  line-height: 1;
  color: ${bgBody};
  background: ${gray500};
`;

export const ImageContainer = styled.div`
  height: 0;
  padding-top: 75%;
  background: ${gray200} url(${props => props.bgImage}) no-repeat center;
  background-size: cover;
`;
